(() => {
  const setupFaq = (root) => {
    if (!root || root.dataset.faqReady === 'true') return;

    const tabs = Array.from(root.querySelectorAll('[data-faq-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-faq-panel]'));
    if (!tabs.length || !panels.length) return;

    root.dataset.faqReady = 'true';
    root.classList.add('is-enhanced');

    const getKeyFromHash = () => {
      const hash = window.location.hash.replace(/^#/, '');
      const panel = panels.find((candidate) => candidate.id === hash);
      return panel ? panel.dataset.faqPanel : '';
    };

    const activate = (key, options = {}) => {
      const activeTab = tabs.find((tab) => tab.dataset.faqTab === key) || tabs[0];
      const activeKey = activeTab.dataset.faqTab;

      tabs.forEach((tab) => {
        const selected = tab === activeTab;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.faqPanel !== activeKey;
      });

      const activePanel = panels.find((panel) => panel.dataset.faqPanel === activeKey);
      if (activePanel && !activePanel.querySelector('details[open]')) {
        activePanel.querySelector('details')?.setAttribute('open', '');
      }

      const tabRail = activeTab.parentElement;
      if (tabRail) {
        const targetLeft = activeTab.offsetLeft - (tabRail.clientWidth - activeTab.offsetWidth) / 2;
        tabRail.scrollTo({ left: Math.max(0, targetLeft), behavior: options.instant ? 'auto' : 'smooth' });
      }

      if (options.updateHash && activePanel) {
        history.replaceState(null, '', `#${activePanel.id}`);
      }
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        activate(tab.dataset.faqTab, { updateHash: true });
      });

      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = index;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        tabs[nextIndex].focus();
        activate(tabs[nextIndex].dataset.faqTab, { updateHash: true });
      });
    });

    panels.forEach((panel) => {
      panel.querySelectorAll('details').forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          panel.querySelectorAll('details[open]').forEach((other) => {
            if (other !== item) other.removeAttribute('open');
          });
        });
      });
    });

    window.addEventListener('hashchange', () => {
      const key = getKeyFromHash();
      if (key) activate(key, { instant: true });
    });

    activate(getKeyFromHash() || tabs[0].dataset.faqTab, { instant: true });
  };

  const setupAll = (scope = document) => {
    scope.querySelectorAll('[data-ozana-faq]').forEach(setupFaq);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupAll());
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
})();
